import { useViewerRoles } from '@treams/treams-hooks';
import { RoleType } from '@treams/treams-network';

import { DefaultSettingsItems } from './DefaultSettingsItems';
import { EngagementOfficerItems } from './EngagementOfficerItems';
import { HRBusinessPartnerItems } from './HRBusinessPartnerItems';

export default function SettingsNav() {
	const { roles } = useViewerRoles();

	const itemsForRole: Partial<Record<RoleType, JSX.Element>> = {
		[RoleType.HrBusinessPartner]: <HRBusinessPartnerItems />,
		[RoleType.EngagementOfficer]: <EngagementOfficerItems />,
	};

	const roleTypes = roles.map((role) => role.role.type);
	return roleTypes.map((type) => itemsForRole[type]).find(Boolean) ?? <DefaultSettingsItems />;
}
